export const sizeMapping = {
  small: {
    padding: 'var(--spacing-none) var(--spacing-xxxs)',
    height: '18px',
    borderRadius: 'var(--radius-xs)',
  },
  medium: {
    padding: 'var(--spacing-none) var(--spacing-xxs)',
    height: '24px',
    borderRadius: 'var(--radius-md)',
  },
};
